import { lazy } from 'react';
import Template from '../../../core/templates/baseApp';

const AreaEnemHomePage = lazy(() => import('../pages/Home'));
const AreaEnemInstructionsPage = lazy(() => import('../pages/Instructions'));
const AreaEnemExamPage = lazy(() => import('../pages/Exam'));
const AreaEnemResultPage = lazy(() => import('../pages/Result'));
const AreaEnemReviewPage = lazy(() => import('../pages/Review'));
const AreaEnemResolutionsPage = lazy(() => import('../pages/Resolutions'));

/*
 * Montado em /area-enem (core/routes). Como no simulado Enem, so a prova fica
 * em tela cheia, sem menu; as demais telas usam o template da plataforma.
 */
export const AreaEnemRoutes = [
  {
    path: '',
    element: (
      <Template>
        <AreaEnemHomePage />
      </Template>
    ),
  },
  {
    path: 'provas/:examId/instrucoes',
    element: (
      <Template>
        <AreaEnemInstructionsPage />
      </Template>
    ),
  },
  {
    path: 'provas/:examId',
    element: <AreaEnemExamPage />,
  },
  {
    path: 'provas/:examId/resultado',
    element: (
      <Template>
        <AreaEnemResultPage />
      </Template>
    ),
  },
  {
    path: 'provas/:examId/resultado/questao/:questionId',
    element: (
      <Template>
        <AreaEnemReviewPage />
      </Template>
    ),
  },
  {
    path: 'resolucoes',
    element: (
      <Template>
        <AreaEnemResolutionsPage />
      </Template>
    ),
  },
];
